var storefrontApp = angular.module("storefrontApp");

//#region Format Query String with Space
storefrontApp.filter("formatQueryStringWithSpace", function () {
    return function (X) {
        if (X != undefined) return X.replace(/\s/g, "-").toLowerCase();
        else return X;
    };
});
//#endregion

//#region mm to inches
storefrontApp.filter("mmToinches", function () {
    return function (measurement) {
        return angular.isDefined(measurement)
            ? (measurement / 25.4).toFixed(2)
            : 0;
    };
});
//#endregion

//#region Minutes to Hours & Minutes
storefrontApp.filter("minToHrMin", function () {
    return function (minutes) {
        var str = "";
        if (!isNaN(minutes) && minutes >= 0) {
            var hours = Math.floor(minutes / 60);
            var mins = Math.floor(minutes % 60);
            if (hours > 0) str += hours + (hours == 1 ? " hr " : " hrs ");
            if (mins > 0) str += mins + (mins == 1 ? " min" : " mins");
            if (hours == 0 && mins == 0) str += mins + " mins";
        }
        return str;
    };
});
//#endregion

//#region Plural Product Type
storefrontApp.filter("pluralProductType", function (productTypeFilter) {
    return function (productType) {
        var productType = productTypeFilter(productType);
        if (productType.charAt(productType.length - 1) == "y") {
            return productType.slice(0, productType.length - 1) + "ies";
        } else if (productType.charAt(productType.length - 1) == "s") {
            return productType;
        } else {
            return productType + "s";
        }
    };
});
//#endregion

//#region Product Type
storefrontApp.filter("productType", function () {
    return function (productType) {
        switch (productType && productType.toLowerCase()) {
            case "designpack":
                return "Design Pack";
            case "software":
                return "Software";
            case "fontpack":
                return "Font Pack";
            case "handembroidery":
                return "Hand Embroidery";
            case "printart":
                return "Graphic Art";
            case "svg":
                return "SVG Cut files";
            case "projectpack":
                return "Project Pack";
            case "stockdesign":
                return "Embroidery Design";
            case "font":
                return "Font";
            case "customdigitizing":
                return "Custom Digitizing";
            case "video":
                return "Video";
            case 'sewingpdfpatterns':
                return 'Sewing PDF Patterns';
            case 'knittingpdfpatterns':
                return 'Knitting PDF Patterns';
            case 'crochetpdfpatterns':
                return 'Crochet PDF Patterns';
            case 'clothingpdfpatterns':
                return 'Clothing PDF Patterns';
            case 'homeformatfonts':
                return 'Home Format Fonts';
            case 'embrilliancefonts':
                return 'Embrilliance Fonts';
            case 'efpfonts':
                return 'EFP Fonts';
            case 'pulsefonts':
                return 'Pulse Fonts';
            case 'alphabetxpressfonts':
                return 'Alphabet XPress Fonts';
            case 'monograms':
                return 'Monograms';
            case 'appliquefonts':
                return 'Applique Fonts';
            case 'crossstitchpdfpatterns':
                return 'Cross Stitch PDF Patterns';
            case 'fabric':
                return 'Fabric';
            case 'machine':
                return 'Machine';
            case 'foundationpaperpiecingpdfpatterns':
                return 'Foundation Paper Piecing PDF Patterns';
            case 'quiltingpdfpatterns':
                return 'Quilting PDF Patterns';
            default:
                return productType;
        }
    };
});
//#endregion

//#region Replace
storefrontApp.filter("replace", function () {
    return function (input, from, to) {
        input = input || "";
        from = from || "";
        to = to || "";
        return input.replace(new RegExp(from, "g"), to);
    };
});
//#endregion

//#region Slice
storefrontApp.filter("slice", function () {
    return function (arr, start, end) {
        return (arr || []).slice(start, end);
    };
});
//#endregion

// #region Date and Time Filters

storefrontApp.filter("LocaleDate", function(){
    return function(x, delimiter){
        if(x != undefined){
            if(delimiter == undefined){
                return (new Date(x).toLocaleDateString('EN', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }));
            }
            else if (delimiter == '/'){
                return (new Date(x).toLocaleDateString('en-US', { day:'2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }));
            }
        }
        else{
            return x;
        }
    }
});

storefrontApp.filter("LocaleTime", function(){
    return function(x){
        if(x != undefined){
            return new Date(x).toLocaleTimeString('en', { hour: "2-digit", minute: "2-digit", hour12: true, timeZone: 'UTC' });
        }
        else{
            return x;
        }
    }
});

storefrontApp.filter("LocaleDateTime", function(LocaleDateFilter, LocaleTimeFilter){
    return function(x){
        if(x != undefined){
            return LocaleDateFilter(x) + " at " + LocaleTimeFilter(x);
        }
        else{
            return x;
        }
    }
});

storefrontApp.filter('urlEncode', function() {
    return function(input) {
        if(angular.isDefined(input)) {
            return window.encodeURIComponent(input);
        }
        return "";
    }
});

storefrontApp.filter('decimaltoFraction', function(){
    return function(input){
        if (typeof input == 'number' && input == 0.33){
            return "1/3";
        }
        if(typeof input == 'number' && input != Math.round(input)){
            var precision = 10;

            var numerator = Math.round(input * 10 * precision);
            var denominator = 10 * precision;

            function gcd(a, b) {
                return b === 0 ? a : gcd(b, a % b);
            }

            var gcdValue = gcd(numerator, denominator);

            var simplifiedNumerator = numerator / gcdValue;
            var simplifiedDenominator = denominator / gcdValue;

            return simplifiedNumerator+"/"+simplifiedDenominator;
        }
        return input;
    }
})

storefrontApp.filter('fabricLength', function(){
    return function(input){
        if(input.length > 0){
            var result = null;
            angular.forEach(input,function(item){
                if(item.name.toLowerCase() == 'variants'){
                    result =  item.value;
                }
            })
            return result;
        }
        return "";
    }
});

//#endregion

storefrontApp.filter('phoneNumberFormatter', function() {
    return function(input) {
        if (!input) return '';

        // Remove non-numeric characters
        var formattedNumber = input.replace(/[^0-9]/g, '');

        var countryCode, area, front, end, result;

        switch (formattedNumber.length) {
            case 10:
                area = formattedNumber.substring(0, 3);
                front = formattedNumber.substring(3, 6);
                end = formattedNumber.substring(6, 10);
                result = '(' + area + ') ' + front + '-' + end;
                break;
            case 11:
                countryCode = formattedNumber.substring(0, 1);
                area = formattedNumber.substring(1, 4);
                front = formattedNumber.substring(4, 7);
                end = formattedNumber.substring(7, 11);
                result = '+' + countryCode + ' (' + area + ') ' + front + '-' + end;
                break;
            case 12:
                countryCode = formattedNumber.substring(0, 2);
                area = formattedNumber.substring(2, 5);
                front = formattedNumber.substring(5, 8);
                end = formattedNumber.substring(8, 12);
                result = '+' + countryCode + ' (' + area + ') ' + front + '-' + end;
                break;
            case 13:
                countryCode = formattedNumber.substring(0, 3);
                area = formattedNumber.substring(3, 6);
                front = formattedNumber.substring(6, 9);
                end = formattedNumber.substring(9, 13);
                result = '+' + countryCode + ' (' + area + ') ' + front + '-' + end;
                break;
            case 14:
                    countryCode = formattedNumber.substring(0, 4);
                    area = formattedNumber.substring(4, 7);
                    front = formattedNumber.substring(7, 10);
                    end = formattedNumber.substring(10, 14);
                    result = '+' + countryCode + ' (' + area + ') ' + front + '-' + end;
                    break;
            default:
                result = formattedNumber;
                break;
        }

        return result;
    };
});


storefrontApp.filter('usdToEur', ['configs','$filter', function(configs, $filter) {
    return function(input) {
        if (isNaN(input)) {
            return input;
        }
        // Convert USD to EUR
        var convertedValue = input * configs.usdToEuroMultiplier;
        // Format to 2 decimal places
        var formattedValue = convertedValue.toFixed(2);
        // Format as currency
        return $filter('currency')(formattedValue, '€', 2);
    };
}]);

storefrontApp.filter('translateMonth', function() {
    var months  = {
        'January': 'Janvier',
        'February': 'Février',
        'March': 'Mars',
        'April': 'Avril',
        'May': 'Mai',
        'June': 'Juin',
        'July': 'Juillet',
        'August': 'Août',
        'September': 'Septembre',
        'October': 'Octobre',
        'November': 'Novembre',
        'December': 'Décembre'
    };

    return function(input) {
        if (!input){
            return '';
        }

        var parts = input.match(/^(\w+) (\d{2}), (\d{4})$/);
        if (!parts){
            return input;
        }

        var monthEnglish = parts[1];
        var day = parts[2];
        var year = parts[3];

        var monthFrench = months[monthEnglish];
        return monthFrench + ' ' + day + ', ' + year;
    };
});

storefrontApp.filter('shippingLocale', function() {
    return function(key) {
        if (!window.shippingLocale || !key) return '';

        var normalizedKey = key.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        var result = window.shippingLocale;
        var keys = Object.keys(result);
        
        for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            if (prop.toLowerCase() === normalizedKey) {
                return result[prop];
            }
        }
        return key;
    };
});
